import type { ClientRect, Modifier } from '@dnd-kit/core';
import type { Transform } from '@dnd-kit/utilities';

// Clamp a drag transform so the dragging node never leaves the given bounds.
function clampToRect(transform: Transform, rect: ClientRect, bounds: ClientRect): Transform {
  const value = { ...transform };

  if (rect.top + value.y <= bounds.top) {
    value.y = bounds.top - rect.top;
  } else if (rect.bottom + value.y >= bounds.top + bounds.height) {
    value.y = bounds.top + bounds.height - rect.bottom;
  }

  if (rect.left + value.x <= bounds.left) {
    value.x = bounds.left - rect.left;
  } else if (rect.right + value.x >= bounds.left + bounds.width) {
    value.x = bounds.left + bounds.width - rect.right;
  }

  return value;
}

// Restrict movement to the bounds of the dragged item's parent element, so a
// drag can't push the item past the container edge (which would otherwise open
// an unbounded horizontal scroll). Mirrors @dnd-kit/modifiers' modifier of the
// same name, inlined to avoid pulling in the extra package.
export const restrictToParentElement: Modifier = ({
  containerNodeRect,
  draggingNodeRect,
  transform,
}) => {
  if (!draggingNodeRect || !containerNodeRect) return transform;
  return clampToRect(transform, draggingNodeRect, containerNodeRect);
};
